import { SagaIterator } from 'redux-saga';
import { all, put, call, takeLatest } from 'redux-saga/effects';
import { MCAFirebaseSaga } from '../root-saga';
import _ from 'lodash';
import {
  CooksMealProps,
  FirestoreSnapshot,
  GET_COOK_MEALS,
  ADD_REPORT,
  GetMealAction,
  GetReviewsAction,
  AddReportAction,
  UserReviews,
  GET_REVIEWS,
} from './types';
import { setMeals, setReviews } from './actions';
import { setLoading, setError } from '../app-globals/actions';
import { firestore } from '../../constants/firebase';

function* fetchMyMeals({ cookid }: GetMealAction): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Fetching Meals'));
    const mealRef = firestore.collection('meals').where('cook', '==', cookid);

    const snapshot = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      mealRef
    );
    const meal: CooksMealProps[] = [];
    snapshot.forEach((item: FirestoreSnapshot) => {
      const body = {
        id: item.id,
        ...item.data(),
        mealprice: item.data().price,
      };
      meal.push(body);
    });
    yield put(setMeals(_.orderBy(meal, ['timeadded'], 'desc')));
    yield put(setLoading(false, ''));
  } catch (e) {
    yield put(setLoading(false, ''));
  }
}

function* addReport({ report }: AddReportAction): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Adding Report'));
    const body = {
      ...report,
    };
    const addReport = yield call(
      MCAFirebaseSaga.firestore.addDocument,
      'reportuser',
      body
    );
    console.log(addReport);
    yield put(setLoading(false, ''));
  } catch (e) {
    yield put(setError(true, 'Error reporting cook'));
    yield put(setLoading(false, ''));
  }
}

function* fetchMealUserReviews({ meal }: GetReviewsAction): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Fetching Meals'));

    const firestoreGet = MCAFirebaseSaga.firestore.getCollection;
    const ratingRef = firestore.collection('rating');
    const usersRef = firestore.collection('users');
    const mealReviewsRef = ratingRef.where('meal', '==', meal.id);

    const [myUsers, myReviews] = yield all([
      call(firestoreGet, usersRef),
      call(firestoreGet, mealReviewsRef),
    ]);
    const reviews: UserReviews[] = [];
    myReviews.forEach((item: FirestoreSnapshot) => {
      myUsers.forEach((userItem: FirestoreSnapshot) => {
        if (
          item.data().ratedby === userItem.data().userid &&
          userItem.data().accountType === 'i seek'
        ) {
          const timeadded = item.data().timeadded.toDate();
          delete item.data().timeadded;
          const body = {
            mealid: item.data().meal,
            firstName: userItem.data().firstName,
            image: userItem.data().image,
            message: item.data().message,
            rate: item.data().rate,
            timeadded,
          };
          reviews.push(body);
        }
      });
    });
    yield put(setReviews(reviews));
    yield put(setLoading(false, ''));
  } catch (e) {
    yield put(setLoading(false, ''));
  }
}

export function* CooksProfileMealSaga() {
  yield all([
    takeLatest(GET_COOK_MEALS, fetchMyMeals),
    takeLatest(ADD_REPORT, addReport),
    takeLatest(GET_REVIEWS, fetchMealUserReviews),
  ]);
}
